const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function PaymentTestModeBanner() {
  if (!clientToken) {
    return (
      <div className="w-full bg-destructive/10 border-b border-destructive/30 px-4 py-2 text-center text-xs text-destructive">
        Production checkout is not configured. Complete payment go-live to accept real payments.
      </div>
    );
  }
  if (clientToken.startsWith("pk_test_")) {
    return (
      <div className="w-full bg-amber-500/10 border-b border-amber-500/30 px-4 py-1.5 text-center text-[11px] text-amber-700 dark:text-amber-300 font-mono">
        Test mode — use card 4242 4242 4242 4242 with any future expiry and CVC.
      </div>
    );
  }
  return null;
}